import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/3xL1jkjmSyiggyKFQmbzxH/_DSC8261.webp';
export function DiscoverBrandSection() {
  return <section className="py-24 md:py-32 bg-white" data-id="element-63">
      <div className="container mx-auto px-6 md:px-12" data-id="element-64">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-16 lg:gap-24" data-id="element-65">
          {/* Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-66">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-67">
              <span className="text-robeta-copper text-xs font-bold uppercase tracking-wide-editorial block mb-8" data-id="element-68">
                Our Story
              </span>

              <blockquote className="text-3xl md:text-4xl font-light text-robeta-black leading-tight mb-10 italic font-serif" data-id="element-69">
                "We don't just build camper vans; we craft mobile sanctuaries
                that inspire you to explore the world without leaving comfort
                behind."
              </blockquote>

              <p className="text-robeta-black/70 font-light leading-relaxed mb-8" data-id="element-70">
                Founded in Slovenia, Robeta has quickly risen to become one of
                Europe's most respected independent manufacturers. Our
                philosophy is simple: listen to the traveler, innovate
                constantly, and never compromise on quality.
              </p>

              <div className="flex flex-col space-y-4" data-id="element-71">
                <Link to="/about-robeta" className="inline-flex items-center text-robeta-black font-bold uppercase tracking-widest hover:text-robeta-copper transition-colors group" data-id="element-72">
                  About Us
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-73" />
                </Link>
                <Link to="/about-robeta" className="inline-flex items-center text-robeta-black font-bold uppercase tracking-widest hover:text-robeta-copper transition-colors group" data-id="element-74">
                  Sustainability
                  <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-75" />
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="w-full lg:w-1/2 aspect-[4/5] relative overflow-hidden" data-id="element-76">
            <img src={IMAGE_URL} alt="Robeta Brand Story" className="w-full h-full object-cover" data-id="element-77" />
            <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-transparent" data-id="element-78" />
          </motion.div>
        </div>
      </div>
    </section>;
}